/**
 * L'INTERRUPTEUR DU PAIEMENT, cote interface. Un seul, et c'est tout l'objet
 * de ce fichier.
 *
 * Rien n'est vendu pour l'instant : les modes sont gratuits, aucune publicite
 * n'est diffusee, et une page qui promet « plus aucune publicite » vendrait
 * donc la disparition de quelque chose qui n'existe pas. Toute la surface de
 * paiement est masquee jusqu'a nouvel ordre.
 *
 * MASQUE, PAS SUPPRIME, et la distinction est le point important : le serveur
 * garde ses routes (/purchase/session, /purchase/confirm, le webhook), la page
 * d'achat garde son code, les avatars payants gardent leurs images. Ce qui
 * disparait, ce sont les CHEMINS qui y menent. Reactiver n'est donc pas un
 * developpement, c'est passer cette constante a `true` : rien a reecrire, rien
 * a se rappeler, rien a oublier.
 *
 * Ce que cette constante commande, et rien d'autre :
 *   - la route /purchase, qui retombe sur l'accueil (jamais un cul-de-sac)
 *   - le bouton « Voir les achats » de l'ecran de compte
 *   - la grille des avatars payants, POUR QUI N'A PAS PAYE (cf. plus bas)
 *
 * TROIS CHOSES RESTENT VISIBLES, DELIBEREMENT :
 *
 *   Le badge des modes dans le selecteur, avec son infobulle « Gratuit
 *   jusqu'au {date} ». Ce n'est pas une porte vers l'achat, c'est un cadeau
 *   qui annonce une gratuite : le masquer ne cacherait rien, cela ferait juste
 *   perdre l'information.
 *
 *   Un compte DEJA PAYE garde ses avatars payants et le constat qui dit qu'il
 *   a debloque le jeu. Ce n'est plus une surface de vente pour lui, c'est ce
 *   qu'il possede : le masquer lui retirerait ce qu'il a paye.
 *
 *   Le retour de Stripe (`?bought=`) continue de confirmer et de crediter. Il
 *   ne coute rien tant que personne n'achete, et il evite qu'un paiement parti
 *   avant le masquage se perde.
 */
export const PAYMENTS_VISIBLE = false;
